import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { DataTableModuleConfiguration } from '../data-table/datatable-module.config';

interface SoftwareLatestArtifactResponse {
  version?: string;
}

@Injectable({ providedIn: 'root' })
export class FirmwareBundleLatestVersionService {
  private static readonly FIRMWARE_SOFTWARE_ID = '03af1011-b6ff-4329-a642-d65b5ea4df23';

  private http = inject(HttpClient);

  private configuration = inject(DataTableModuleConfiguration);

  private latestVersion$?: Observable<string | undefined>;

  getLatestVersion(): Observable<string | undefined> {
    const workflowApiUrl = this.configuration.apiUrls.workflow;
    if (!workflowApiUrl) {
      return of(undefined);
    }

    if (this.latestVersion$) {
      return this.latestVersion$;
    }

    this.latestVersion$ = this.http.get<SoftwareLatestArtifactResponse>(
      `${workflowApiUrl}/api/v1/software/${FirmwareBundleLatestVersionService.FIRMWARE_SOFTWARE_ID}/artifacts/latest`,
    ).pipe(
      map((response) => response.version?.trim() || undefined),
      catchError(() => of(undefined)),
      shareReplay(1),
    );

    return this.latestVersion$;
  }
}
